// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AppManagerRouteRouteImport } from './routes/_app/manager/route'
import { Route as AuthResetPasswordIndexRouteImport } from './routes/auth/reset-password.index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/auth/forgot-password.index'
import { Route as AuthResetPasswordConfirmationRouteImport } from './routes/auth/reset-password.confirmation'
import { Route as AuthForgotPasswordConfirmationRouteImport } from './routes/auth/forgot-password.confirmation'
import { Route as AppPodcastsChannelUidRouteRouteImport } from './routes/_app/podcasts/$channelUid/route'
import { Route as AppManagerIndexRouteImport } from './routes/_app/manager/index'
import { Route as AppManagerStatisticsRouteImport } from './routes/_app/manager/statistics'
import { Route as AppManagerPlanningRouteRouteImport } from './routes/_app/manager/planning/route'
import { Route as AppPodcastsChannelUidIndexRouteImport } from './routes/_app/podcasts/$channelUid/index'
import { Route as AppPodcastsChannelUidStatisticsRouteImport } from './routes/_app/podcasts/$channelUid/statistics'
import { Route as AppPodcastsChannelUidOnboardingRouteImport } from './routes/_app/podcasts/$channelUid/onboarding'
import { Route as AppPodcastsChannelUidSettingsRouteRouteImport } from './routes/_app/podcasts/$channelUid/settings/route'
import { Route as AppPodcastsChannelUidPlanningRouteRouteImport } from './routes/_app/podcasts/$channelUid/planning/route'
import { Route as AppManagerNewIndexRouteImport } from './routes/_app/manager/new/index'
import { Route as AppManagerPlanningIndexRouteImport } from './routes/_app/manager/planning/index'
import { Route as AppPodcastsChannelUidEpisodesIndexRouteImport } from './routes/_app/podcasts/$channelUid/episodes/index'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidRouteRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/route'
import { Route as AppPodcastsChannelUidSettingsIndexRouteImport } from './routes/_app/podcasts/$channelUid/settings/index'
import { Route as AppPodcastsChannelUidSettingsTeamRouteImport } from './routes/_app/podcasts/$channelUid/settings/team'
import { Route as AppPodcastsChannelUidSettingsShareRouteImport } from './routes/_app/podcasts/$channelUid/settings/share'
import { Route as AppPodcastsChannelUidSettingsSettingsRouteImport } from './routes/_app/podcasts/$channelUid/settings/settings'
import { Route as AppPodcastsChannelUidSettingsMonetizationRouteImport } from './routes/_app/podcasts/$channelUid/settings/monetization'
import { Route as AppPodcastsChannelUidSettingsJinglesRouteImport } from './routes/_app/podcasts/$channelUid/settings/jingles'
import { Route as AppPodcastsChannelUidSettingsGeolocationRouteImport } from './routes/_app/podcasts/$channelUid/settings/geolocation'
import { Route as AppPodcastsChannelUidSettingsDirectoriesRouteImport } from './routes/_app/podcasts/$channelUid/settings/directories'
import { Route as AppPodcastsChannelUidSettingsDetailsRouteImport } from './routes/_app/podcasts/$channelUid/settings/details'
import { Route as AppPodcastsChannelUidSettingsAudioRouteImport } from './routes/_app/podcasts/$channelUid/settings/audio'
import { Route as AppPodcastsChannelUidPlanningIndexRouteImport } from './routes/_app/podcasts/$channelUid/planning/index'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidIndexRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/index'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidStatisticsRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/statistics'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidShareRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/share'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidSettingsRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/settings'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidMonetizationRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/monetization'
import { Route as AppPodcastsChannelUidEpisodesEpisodeUidDetailsRouteImport } from './routes/_app/podcasts/$channelUid/episodes/$episodeUid/details'

const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AppManagerRouteRoute = AppManagerRouteRouteImport.update({
            id: '/manager',path: '/manager',getParentRoute: () => AppRouteRoute
          })
const AuthResetPasswordIndexRoute = AuthResetPasswordIndexRouteImport.update({
            id: '/reset-password/',path: '/reset-password/',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
            id: '/forgot-password/',path: '/forgot-password/',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordConfirmationRoute = AuthResetPasswordConfirmationRouteImport.update({
            id: '/reset-password/confirmation',path: '/reset-password/confirmation',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordConfirmationRoute = AuthForgotPasswordConfirmationRouteImport.update({
            id: '/forgot-password/confirmation',path: '/forgot-password/confirmation',getParentRoute: () => AuthRoute
          })
const AppPodcastsChannelUidRouteRoute = AppPodcastsChannelUidRouteRouteImport.update({
            id: '/podcasts/$channelUid',path: '/podcasts/$channelUid',getParentRoute: () => AppRouteRoute
          })
const AppManagerIndexRoute = AppManagerIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppManagerRouteRoute
          })
const AppManagerStatisticsRoute = AppManagerStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => AppManagerRouteRoute
          })
const AppManagerPlanningRouteRoute = AppManagerPlanningRouteRouteImport.update({
            id: '/planning',path: '/planning',getParentRoute: () => AppManagerRouteRoute
          })
const AppPodcastsChannelUidIndexRoute = AppPodcastsChannelUidIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppPodcastsChannelUidStatisticsRoute = AppPodcastsChannelUidStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppPodcastsChannelUidOnboardingRoute = AppPodcastsChannelUidOnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppPodcastsChannelUidSettingsRouteRoute = AppPodcastsChannelUidSettingsRouteRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppPodcastsChannelUidPlanningRouteRoute = AppPodcastsChannelUidPlanningRouteRouteImport.update({
            id: '/planning',path: '/planning',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppManagerNewIndexRoute = AppManagerNewIndexRouteImport.update({
            id: '/new/',path: '/new/',getParentRoute: () => AppManagerRouteRoute
          })
const AppManagerPlanningIndexRoute = AppManagerPlanningIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppManagerPlanningRouteRoute
          })
const AppPodcastsChannelUidEpisodesIndexRoute = AppPodcastsChannelUidEpisodesIndexRouteImport.update({
            id: '/episodes/',path: '/episodes/',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute = AppPodcastsChannelUidEpisodesEpisodeUidRouteRouteImport.update({
            id: '/episodes/$episodeUid',path: '/episodes/$episodeUid',getParentRoute: () => AppPodcastsChannelUidRouteRoute
          })
const AppPodcastsChannelUidSettingsIndexRoute = AppPodcastsChannelUidSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsTeamRoute = AppPodcastsChannelUidSettingsTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsShareRoute = AppPodcastsChannelUidSettingsShareRouteImport.update({
            id: '/share',path: '/share',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsSettingsRoute = AppPodcastsChannelUidSettingsSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsMonetizationRoute = AppPodcastsChannelUidSettingsMonetizationRouteImport.update({
            id: '/monetization',path: '/monetization',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsJinglesRoute = AppPodcastsChannelUidSettingsJinglesRouteImport.update({
            id: '/jingles',path: '/jingles',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsGeolocationRoute = AppPodcastsChannelUidSettingsGeolocationRouteImport.update({
            id: '/geolocation',path: '/geolocation',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsDirectoriesRoute = AppPodcastsChannelUidSettingsDirectoriesRouteImport.update({
            id: '/directories',path: '/directories',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsDetailsRoute = AppPodcastsChannelUidSettingsDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidSettingsAudioRoute = AppPodcastsChannelUidSettingsAudioRouteImport.update({
            id: '/audio',path: '/audio',getParentRoute: () => AppPodcastsChannelUidSettingsRouteRoute
          })
const AppPodcastsChannelUidPlanningIndexRoute = AppPodcastsChannelUidPlanningIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPodcastsChannelUidPlanningRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidIndexRoute = AppPodcastsChannelUidEpisodesEpisodeUidIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidStatisticsRoute = AppPodcastsChannelUidEpisodesEpisodeUidStatisticsRouteImport.update({
            id: '/statistics',path: '/statistics',getParentRoute: () => AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidShareRoute = AppPodcastsChannelUidEpisodesEpisodeUidShareRouteImport.update({
            id: '/share',path: '/share',getParentRoute: () => AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidSettingsRoute = AppPodcastsChannelUidEpisodesEpisodeUidSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidMonetizationRoute = AppPodcastsChannelUidEpisodesEpisodeUidMonetizationRouteImport.update({
            id: '/monetization',path: '/monetization',getParentRoute: () => AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute
          })
const AppPodcastsChannelUidEpisodesEpisodeUidDetailsRoute = AppPodcastsChannelUidEpisodesEpisodeUidDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute
          })





const AppManagerPlanningRouteRouteChildren = {
  AppManagerPlanningIndexRoute: AppManagerPlanningIndexRoute
}

const AppManagerPlanningRouteRouteWithChildren = AppManagerPlanningRouteRoute._addFileChildren(AppManagerPlanningRouteRouteChildren)



const AppManagerRouteRouteChildren = {
  AppManagerPlanningRouteRoute: AppManagerPlanningRouteRouteWithChildren,AppManagerStatisticsRoute: AppManagerStatisticsRoute,AppManagerIndexRoute: AppManagerIndexRoute,AppManagerNewIndexRoute: AppManagerNewIndexRoute
}

const AppManagerRouteRouteWithChildren = AppManagerRouteRoute._addFileChildren(AppManagerRouteRouteChildren)




const AppPodcastsChannelUidPlanningRouteRouteChildren = {
  AppPodcastsChannelUidPlanningIndexRoute: AppPodcastsChannelUidPlanningIndexRoute
}

const AppPodcastsChannelUidPlanningRouteRouteWithChildren = AppPodcastsChannelUidPlanningRouteRoute._addFileChildren(AppPodcastsChannelUidPlanningRouteRouteChildren)




const AppPodcastsChannelUidSettingsRouteRouteChildren = {
  AppPodcastsChannelUidSettingsAudioRoute: AppPodcastsChannelUidSettingsAudioRoute,AppPodcastsChannelUidSettingsDetailsRoute: AppPodcastsChannelUidSettingsDetailsRoute,AppPodcastsChannelUidSettingsDirectoriesRoute: AppPodcastsChannelUidSettingsDirectoriesRoute,AppPodcastsChannelUidSettingsGeolocationRoute: AppPodcastsChannelUidSettingsGeolocationRoute,AppPodcastsChannelUidSettingsJinglesRoute: AppPodcastsChannelUidSettingsJinglesRoute,AppPodcastsChannelUidSettingsMonetizationRoute: AppPodcastsChannelUidSettingsMonetizationRoute,AppPodcastsChannelUidSettingsSettingsRoute: AppPodcastsChannelUidSettingsSettingsRoute,AppPodcastsChannelUidSettingsShareRoute: AppPodcastsChannelUidSettingsShareRoute,AppPodcastsChannelUidSettingsTeamRoute: AppPodcastsChannelUidSettingsTeamRoute,AppPodcastsChannelUidSettingsIndexRoute: AppPodcastsChannelUidSettingsIndexRoute
}

const AppPodcastsChannelUidSettingsRouteRouteWithChildren = AppPodcastsChannelUidSettingsRouteRoute._addFileChildren(AppPodcastsChannelUidSettingsRouteRouteChildren)




const AppPodcastsChannelUidEpisodesEpisodeUidRouteRouteChildren = {
  AppPodcastsChannelUidEpisodesEpisodeUidDetailsRoute: AppPodcastsChannelUidEpisodesEpisodeUidDetailsRoute,AppPodcastsChannelUidEpisodesEpisodeUidMonetizationRoute: AppPodcastsChannelUidEpisodesEpisodeUidMonetizationRoute,AppPodcastsChannelUidEpisodesEpisodeUidSettingsRoute: AppPodcastsChannelUidEpisodesEpisodeUidSettingsRoute,AppPodcastsChannelUidEpisodesEpisodeUidShareRoute: AppPodcastsChannelUidEpisodesEpisodeUidShareRoute,AppPodcastsChannelUidEpisodesEpisodeUidStatisticsRoute: AppPodcastsChannelUidEpisodesEpisodeUidStatisticsRoute,AppPodcastsChannelUidEpisodesEpisodeUidIndexRoute: AppPodcastsChannelUidEpisodesEpisodeUidIndexRoute
}

const AppPodcastsChannelUidEpisodesEpisodeUidRouteRouteWithChildren = AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute._addFileChildren(AppPodcastsChannelUidEpisodesEpisodeUidRouteRouteChildren)



const AppPodcastsChannelUidRouteRouteChildren = {
  AppPodcastsChannelUidPlanningRouteRoute: AppPodcastsChannelUidPlanningRouteRouteWithChildren,AppPodcastsChannelUidSettingsRouteRoute: AppPodcastsChannelUidSettingsRouteRouteWithChildren,AppPodcastsChannelUidOnboardingRoute: AppPodcastsChannelUidOnboardingRoute,AppPodcastsChannelUidStatisticsRoute: AppPodcastsChannelUidStatisticsRoute,AppPodcastsChannelUidIndexRoute: AppPodcastsChannelUidIndexRoute,AppPodcastsChannelUidEpisodesEpisodeUidRouteRoute: AppPodcastsChannelUidEpisodesEpisodeUidRouteRouteWithChildren,AppPodcastsChannelUidEpisodesIndexRoute: AppPodcastsChannelUidEpisodesIndexRoute
}

const AppPodcastsChannelUidRouteRouteWithChildren = AppPodcastsChannelUidRouteRoute._addFileChildren(AppPodcastsChannelUidRouteRouteChildren)



const AppRouteRouteChildren = {
  AppManagerRouteRoute: AppManagerRouteRouteWithChildren,AppPodcastsChannelUidRouteRoute: AppPodcastsChannelUidRouteRouteWithChildren
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)




const AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,AuthSignUpRoute: AuthSignUpRoute,AuthForgotPasswordConfirmationRoute: AuthForgotPasswordConfirmationRoute,AuthResetPasswordConfirmationRoute: AuthResetPasswordConfirmationRoute,AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,AuthResetPasswordIndexRoute: AuthResetPasswordIndexRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRouteRoute: AppRouteRouteWithChildren,AuthRoute: AuthRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)